import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Styles } from './style/programmes'
// import Aos from 'aos';
import 'aos/dist/aos.css'
import { Link } from 'react-router-dom'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import BreadcrumbBox from '../../components/common/Breadcrumb'
import PopularPrograme from './PopularPrograme'
import ProgramSingle from './ProgramSingle'
import { useLocation, useParams } from 'react-router-dom'
import SearchResearcher from '../../components/SearchResearcher'
import { resetMetaTags, setMetaTags } from '../../helper/setMetaTags'
function useQuery() {
  const { search } = useLocation()
  return React.useMemo(() => new URLSearchParams(search), [search])
}

const SchoolDetail = ({ id }) => {
  const params = useParams()
  let school_result = []

  useEffect(() => {
    window.scrollTo(0, 0)
    return () => {}
  }, [])

  const [ddata, setDdata] = useState([])

  useEffect(() => {
    document.body.setAttribute('id', `pageId-${id}`)
    fetch('https://api.shooliniuniversity.com/GetHprogramAPI', {
      method: 'post',
      headers: new Headers({
        'Content-Type': 'application/json',
        // 'Content-Type': 'application/x-www-form-urlencoded',
      }),
      body: JSON.stringify({
        auth: 'shoolini@999',
        url: params.slug,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        setDdata(res)
        setMetaTags(res.success[0])
      })

    return () => {
      document.title = 'Shoolini University'
      resetMetaTags()
      document.body.removeAttribute('pageId')
    }
  }, [])

  school_result = ddata?.success?.[0]
  // console.log(school_result, 'school data')
  if (school_result) {
    document.title = `${school_result?.title} | 'Shoolini University`
  }

  var s = document.createElement('script')
  s.type = 'text/javascript'
  s.async = true
  s.src = 'https://widgets.nopaperforms.com/emwgts.js'
  document.body.appendChild(s)

  return (
    <>
      <Styles>
        <Header />
        <BreadcrumbBox title={school_result?.title} />

        <section className="SchoolDetail x">
          <Container>
            <Row>
              <Col md="7" lg="8" className="order-xs-2">
                <div className="su-sidebar-content my-5">
                  {/* <div className="suContent">
                    <h3>{school_result?.title}</h3>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: school_result?.content,
                      }}
                    ></p>
                  </div> */}

                  <div class="su-core-title-item-title-wrap">
                    <h3 class="su-core-title-item-title">Programmes</h3>
                    <div class="su-core-title-item-divider"></div>
                  </div>

                  <section class="main-section">
                    <div class="courses row">
                      {school_result?.courses?.map((row, index) => {
                        return (
                          <div className="col-md-6">
                            <div key={index} className="cuCourse">
                              <div className="detailView">
                                <div key={index}>
                                  {' '}
                                  <h3> {row.title} </h3>
                                  <p>
                                    {' '}
                                    <strong> Eligibility </strong>
                                    {row.eligibility}{' '}
                                  </p>
                                </div>
                              </div>

                              <div className="sideOpen">
                                <ProgramSingle slug={row.slug} />
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </section>

                  <div class="su-core-title-item-title-wrap">
                    <h3 class="su-core-title-item-title">Student Voices</h3>
                    <div class="su-core-title-item-divider"></div>
                  </div>
                  {school_result?.testimonial && (
                    <section className="userTestimonial">
                      <Row>
                        {school_result?.testimonial.map((row, index) => {
                          return (
                            <div className="col-md-6 col-12" key={index}>
                              <div className="userDetailCard">
                                <div className="row">
                                  <figure className="cj-media-left col-4">
                                    <p className="user-image">
                                      <img
                                        className="img-fluid"
                                        src={row.imageurl}
                                        alt=""
                                      />
                                    </p>
                                  </figure>
                                  <div className="userContent col-8">
                                    <h5>{row.name}</h5>
                                    <span>{row.content}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </Row>
                    </section>
                  )}
                </div>
              </Col>
              <Col md="5" lg="4" className="order-xs-1">
                <div className="sideBarpage course-search">
                  <SearchResearcher />
                  <div className="sideBarNew">
                    <div className="enqForm">
                      <div
                        className="npf_wgts"
                        data-height="500px"
                        data-w="7d1b402b547afa4d6a10968170a856b6"
                      ></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <Footer />
      </Styles>
    </>
  )
}

export default SchoolDetail
